import { useState } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './components/ui/card'
import { Badge } from './components/ui/badge'
import { Button } from './components/ui/button'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './components/ui/table'

import { CheckCircle, TrendingUp, Target, Calendar, FileText, BarChart3 } from 'lucide-react'
import './App.css'

function App() {
  const [activeSection, setActiveSection] = useState('overview')

  const seoTopics = [
    { categoria: "Financiación y trámites", titulo: "Crédito vehicular en Ecuador: cómo funciona y requisitos 2025", frase: "crédito vehicular Ecuador" },
    { categoria: "Financiación y trámites", titulo: "Documentos para comprar un auto nuevo en Ecuador: guía 2025", frase: "documentos para comprar auto nuevo" },
    { categoria: "Financiación y trámites", titulo: "¿Auto nuevo o seminuevo financiado? Comparativa y consejos", frase: "auto nuevo o seminuevo financiado" },
    { categoria: "Financiación y trámites", titulo: "Cuánto cuesta el seguro de auto nuevo en Ecuador y qué cubre", frase: "seguro auto nuevo Ecuador" },
    { categoria: "Financiación y trámites", titulo: "¿Cuánto debo ganar para financiar un auto nuevo en Ecuador?", frase: "financiar auto nuevo Ecuador" },
    { categoria: "Financiación y trámites", titulo: "Cuáles son las tasas de interés para autos nuevos 2025", frase: "tasas interés auto nuevo Ecuador" },
    { categoria: "Financiación y trámites", titulo: "Pasos para comprar un auto nuevo en Ecuador con crédito", frase: "comprar auto nuevo con crédito Ecuador" },
    { categoria: "Cuidado del vehículo y mantenimiento", titulo: "Cómo cuidar tu auto nuevo y mantener su valor por más tiempo", frase: "cómo cuidar tu auto nuevo" },
    { categoria: "Cuidado del vehículo y mantenimiento", titulo: "Cómo ahorrar combustible sin perder potencia al conducir", frase: "ahorrar combustible sin perder potencia" },
    { categoria: "Cuidado del vehículo y mantenimiento", titulo: "Cómo alargar la vida útil del motor de tu auto nuevo", frase: "vida útil motor auto nuevo" },
    { categoria: "Cuidado del vehículo y mantenimiento", titulo: "¿Qué revisa un mecánico en el mantenimiento de los 30.000 km?", frase: "mantenimiento 30000 km auto" },
    { categoria: "Cuidado del vehículo y mantenimiento", titulo: "10 errores que dañan tu auto nuevo sin que lo sepas", frase: "errores que dañan auto nuevo" },
    { categoria: "Cuidado del vehículo y mantenimiento", titulo: "Mantenimiento ideal para autos nuevos en zonas rurales", frase: "mantenimiento auto zonas rurales" },
    { categoria: "Cuidado del vehículo y mantenimiento", titulo: "¿Qué pasa si no hago el mantenimiento a tiempo?", frase: "consecuencias no hacer mantenimiento auto" },
    { categoria: "Momento ideal de compra", titulo: "Cuándo es el mejor momento para comprar un auto nuevo en Ecuador", frase: "mejor mes para comprar auto nuevo Ecuador" },
    { categoria: "Momento ideal de compra", titulo: "¿Hay ofertas de autos nuevos en fin de año en Ecuador?", frase: "ofertas autos nuevos fin de año Ecuador" },
    { categoria: "Momento ideal de compra", titulo: "¿Es buena idea comprar un auto nuevo en julio-agosto?", frase: "comprar auto nuevo en julio agosto Ecuador" },
    { categoria: "Comparativas y decisiones inteligentes", titulo: "¿Qué SUV es mejor: Chery Tiggo 2 Pro vs Renault Duster?", frase: "chery tiggo 2 pro vs renault duster" },
    { categoria: "Comparativas y decisiones inteligentes", titulo: "¿Qué camioneta es mejor para uso comercial en Ecuador?", frase: "mejor camioneta uso comercial Ecuador" },
    { categoria: "Comparativas y decisiones inteligentes", titulo: "Comparativa entre autos automáticos y CVT: ventajas y desventajas", frase: "autos automaticos vs CVT Ecuador" },
    { categoria: "Comparativas y decisiones inteligentes", titulo: "SUV vs Sedán: cuál es mejor según tu estilo de vida", frase: "SUV vs sedán Ecuador" },
    { categoria: "Comparativas y decisiones inteligentes", titulo: "Auto nuevo vs seminuevo 2025: pros y contras actualizados", frase: "auto nuevo vs seminuevo Ecuador 2025" },
    { categoria: "Estilo de vida y perfil del conductor", titulo: "Autos ideales para familias con niños pequeños en Ecuador", frase: "autos para familias niños Ecuador" },
    { categoria: "Estilo de vida y perfil del conductor", titulo: "¿Qué auto comprar si vives en una zona montañosa?", frase: "auto para zona montañosa Ecuador" },
    { categoria: "Estilo de vida y perfil del conductor", titulo: "¿Cuál es el mejor auto para recorrer largas distancias en Ecuador?", frase: "mejor auto para viajar Ecuador" },
    { categoria: "Estilo de vida y perfil del conductor", titulo: "¿Qué tipo de vehículo te conviene si eres emprendedor?", frase: "auto para emprendedor Ecuador" }
  ]

  const topPerformingPages = [
    "¿Cada cuántos km se hace el cambio de aceite?",
    "SUV ideal para familias en Ecuador",
    "Primer mantenimiento de un auto nuevo"
  ]

  const accomplishments = [
    "Estructuración del sitio web desde cero",
    "Integración con la API de indexación de Google",
    "Reestructuración del sitemap XML",
    "Enlace con Google Search Console",
    "Publicación de más de 20 artículos optimizados para SEO"
  ]

  const categories = [...new Set(seoTopics.map(topic => topic.categoria))]

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Informe de Avance SEO – Comercial Hidrobo
          </h1>
          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-600">
            <div className="flex items-center gap-2">
              <Calendar className="w-4 h-4" />
              <span><strong>Periodo:</strong> Junio - 15 Julio 2025</span>
            </div>
            <div className="flex items-center gap-2">
              <FileText className="w-4 h-4" />
              <span><strong>Responsable:</strong> Santiago Oña – Creative Web</span>
            </div>
          </div>
          <p className="mt-4 text-lg text-gray-700 max-w-3xl mx-auto">
            <strong>Objetivo:</strong> Posicionamiento SEO orgánico del sitio web www.comercialhidrobo.com
          </p>
        </div>

        {/* Navigation */}
        <div className="flex flex-wrap justify-center gap-2 mb-8">
          {[
            { id: 'overview', label: 'Resumen', icon: BarChart3 },
            { id: 'technical', label: 'Fundamentos Técnicos', icon: CheckCircle },
            { id: 'content', label: 'Producción de Contenidos', icon: FileText },
            { id: 'results', label: 'Resultados', icon: TrendingUp },
            { id: 'topics', label: 'Nuevos Temas', icon: Target }
          ].map(({ id, label, icon: Icon }) => (
            <Button
              key={id}
              variant={activeSection === id ? "default" : "outline"}
              onClick={() => setActiveSection(id)}
              className="flex items-center gap-2"
            >
              <Icon className="w-4 h-4" />
              {label}
            </Button>
          ))}
        </div>

        {/* Content Sections */}
        {activeSection === 'overview' && (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <CheckCircle className="w-5 h-5 text-green-600" />
                  Logros Principales
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {accomplishments.map((item, index) => (
                    <li key={index} className="flex items-start gap-2 text-sm">
                      <CheckCircle className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <TrendingUp className="w-5 h-5 text-blue-600" />
                  Páginas Top
                </CardTitle>
                <CardDescription>Mejor desempeño inicial</CardDescription>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {topPerformingPages.map((page, index) => (
                    <li key={index} className="text-sm p-2 bg-blue-50 rounded">
                      {page}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Target className="w-5 h-5 text-purple-600" />
                  Próximos Pasos
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  <div className="p-3 bg-purple-50 rounded">
                    <p className="font-medium text-sm">Objetivo Julio-Agosto</p>
                    <p className="text-sm text-gray-600">20-25 artículos por mes</p>
                  </div>
                  <div className="p-3 bg-green-50 rounded">
                    <p className="font-medium text-sm">Monitoreo</p>
                    <p className="text-sm text-gray-600">Search Console activo</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        )}

        {activeSection === 'technical' && (
          <Card>
            <CardHeader>
              <CardTitle>Fase inicial: Mayo 2025 – Fundamentos técnicos</CardTitle>
              <CardDescription>
                Durante mayo se sentaron las bases técnicas para asegurar el correcto posicionamiento de los contenidos en Google
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="p-4 border rounded-lg">
                    <h3 className="font-semibold mb-2 flex items-center gap-2">
                      <CheckCircle className="w-5 h-5 text-green-600" />
                      Estructuración del sitio web desde cero
                    </h3>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• Optimización de URLs amigables y jerarquía de contenidos</li>
                      <li>• Incorporación de categorías temáticas (autos nuevos, postventa, consejos, SUV, etc.)</li>
                    </ul>
                  </div>
                  <div className="p-4 border rounded-lg">
                    <h3 className="font-semibold mb-2 flex items-center gap-2">
                      <CheckCircle className="w-5 h-5 text-green-600" />
                      Integración con la API de indexación de Google
                    </h3>
                    <p className="text-sm text-gray-600">
                      Se implementó el sistema automático de indexación inmediata mediante RankMath + Google Indexing API. 
                      Esto permite que los nuevos artículos aparezcan más rápido en los resultados de búsqueda.
                    </p>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="p-4 border rounded-lg">
                    <h3 className="font-semibold mb-2 flex items-center gap-2">
                      <CheckCircle className="w-5 h-5 text-green-600" />
                      Reestructuración del sitemap XML
                    </h3>
                    <p className="text-sm text-gray-600">
                      Mejora del mapa del sitio para facilitar la lectura por parte de Google.
                    </p>
                  </div>
                  <div className="p-4 border rounded-lg">
                    <h3 className="font-semibold mb-2 flex items-center gap-2">
                      <CheckCircle className="w-5 h-5 text-green-600" />
                      Enlace con Google Search Console
                    </h3>
                    <p className="text-sm text-gray-600">
                      Verificación completa del dominio, seguimiento de cobertura, clics y posicionamiento.
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        )}

        {activeSection === 'content' && (
          <Card>
            <CardHeader>
              <CardTitle>Producción de contenidos: Junio y primera mitad de Julio</CardTitle>
              <CardDescription>
                Desde junio se inició la estrategia de contenidos, publicando más de 40 artículos optimizados para SEO
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {[
                  "Palabra clave basada en búsquedas reales",
                  "Título optimizado para Google",
                  "Meta descripción atractiva",
                  "Imágenes con texto alternativo",
                  "Estructura jerárquica (H1, H2, H3)",
                  "Enlaces internos y externos"
                ].map((feature, index) => (
                  <div key={index} className="p-3 bg-blue-50 rounded-lg">
                    <div className="flex items-center gap-2">
                      <CheckCircle className="w-4 h-4 text-blue-600" />
                      <span className="text-sm font-medium">{feature}</span>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="mt-8">
                <h3 className="text-lg font-semibold mb-4">Temas bien posicionados</h3>
                <div className="grid md:grid-cols-2 gap-4">
                  {[
                    "Postventa: garantías, servicios, diferencias entre auto nuevo y usado",
                    "Modelos Renault Duster: precios, características, usos",
                    "Mantenimiento: aceite, chequeos a 10.000 y 20.000 km",
                    "Comparativas: marcas y sistemas (automático vs mecánico)",
                    "Guías y consejos: para primer auto, ficha técnica, tipos de carrocería",
                    "Estilo de vida: conducir en ciudad, montaña, usos familiares o comerciales"
                  ].map((topic, index) => (
                    <div key={index} className="p-3 border rounded-lg">
                      <span className="text-sm">{topic}</span>
                    </div>
                  ))}
                </div>
                <div className="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                  <p className="text-sm">
                    <strong>Recomendación:</strong> No insistir en estas temáticas para evitar canibalización de keywords y mantener variedad.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        )}

        {activeSection === 'results' && (
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <TrendingUp className="w-6 h-6 text-green-600" />
                Resultados visibles al 15 de julio
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h3 className="font-semibold mb-4">Logros Alcanzados</h3>
                  <div className="space-y-3">
                    <div className="flex items-center gap-3 p-3 bg-green-50 rounded-lg">
                      <CheckCircle className="w-5 h-5 text-green-600" />
                      <span className="text-sm">Los primeros artículos ya están indexados en Google</span>
                    </div>
                    <div className="flex items-center gap-3 p-3 bg-blue-50 rounded-lg">
                      <TrendingUp className="w-5 h-5 text-blue-600" />
                      <span className="text-sm">Comienzan a recibir impresiones y clics orgánicos, generando tráfico natural sin pago</span>
                    </div>
                  </div>
                </div>
                <div>
                  <h3 className="font-semibold mb-4">Páginas con mejor desempeño inicial</h3>
                  <div className="space-y-2">
                    {topPerformingPages.map((page, index) => (
                      <div key={index} className="p-3 border rounded-lg bg-gradient-to-r from-blue-50 to-purple-50">
                        <span className="text-sm font-medium">{page}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        )}

        {activeSection === 'topics' && (
          <Card>
            <CardHeader>
              <CardTitle>Nuevos temas con alto potencial SEO</CardTitle>
              <CardDescription>
                Temas aún no tratados que tienen alta demanda y gran oportunidad de atraer más visitas
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="mb-6">
                <div className="flex flex-wrap gap-2">
                  {categories.map((category, index) => (
                    <Badge key={index} variant="outline" className="text-xs">
                      {category}
                    </Badge>
                  ))}
                </div>
              </div>
              
              <div className="overflow-x-auto">
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Categoría</TableHead>
                      <TableHead>Título SEO</TableHead>
                      <TableHead>Frase clave</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {seoTopics.map((topic, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <Badge variant="secondary" className="text-xs">
                            {topic.categoria}
                          </Badge>
                        </TableCell>
                        <TableCell className="font-medium">{topic.titulo}</TableCell>
                        <TableCell className="text-sm text-gray-600">{topic.frase}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  )
}

export default App